import Avatar from 'ui/atoms/Avatar/Avatar';
import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import { default as React } from 'react';
import FormField from 'ui/molecules/FormField/FormField';
import InputText from 'ui/atoms/InputText/InputText';
import { useDialogReassign } from './useDialogReassign';

const DialogReassign = ({ open, onCancel, onSuccess }) => {
  const { t, user, comment, onChangeComment, onReassign } = useDialogReassign({ onSuccess });

  return (
    <Dialog
      title={t('assigments:Redo assigment')}
      isOpen={open}
      className={'dialog-reassign'}
      buttonTextSuccess={t('actions:Redo')}
      buttonTextCancel={t('actions:Cancel')}
      onClose={onCancel}
      onSuccess={onReassign}
      onCancel={onCancel}
    >
      <p className="dialog-reassign__text">{t('assigments:Return the task to the student')}</p>
      <div className="dialog-reassign__comment">
        <div className="dialog-reassign__avatar">
          <Avatar image={user.avatar} />
        </div>
        <div className="dialog-reassign__input">
          <FormField isLabelHidden label={t('assigments:Add private comment')}>
            <InputText
              placeholder={t('assigments:Add private comment')}
              value={comment}
              onChange={onChangeComment}
            />
          </FormField>
        </div>
      </div>
    </Dialog>
  );
};

DialogReassign.defaultProps = {
  open: false,
  user: {},
  onSuccess: function () {},
  onCancel: function () {},
};

export default DialogReassign;
